@import (reference) '../../../constants/spacing.module.less';
@import (reference) './shared-fraud-styles.less';

.fraud-icon-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.blocking-blocks {
  .fraud-icon-blocks();
}

.blocking-flags {
  .fraud-icon-flags();
}

.blocking-info {
  .fraud-icon-info();
}
